import React from 'react';
import { useDataContext } from '../context/data';
import translations from '../constants/translations.json';

const DownloadInfo = () => {
  const { language } = useDataContext();

  // App store URLs
  const APP_STORE_URL = 'https://apps.apple.com/app/heywaitr/id1535472240';
  const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.heywaitr';

  return (
    <div className="container max-w-7xl mt-12 sm:mt-20 mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex items-center mb-3 flex-col md:flex-row gap-6">
        <div className="flex-1 space-y-4 sm:space-y-12">
          <h2 className="text-xl sm:text-2xl font-bold">
            {translations[language]?.restaurants_download_title}
          </h2>
          <p className="text-lg sm:text-xl font-light">
            {translations[language]?.restaurants_download_description}
          </p>
          <div className="flex space-x-4 flex-wrap">
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block transition-transform hover:scale-105 max-w-[130px] sm:max-w-full"
            >
              <img src="app-store-badge.png" alt="Download on App Store" />
            </a>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block transition-transform hover:scale-105 max-w-[146.55px] sm:max-w-full"
            >
              <img src="google-play-badge.png" alt="Get it on Google Play" />
            </a>
          </div>
        </div>
        <div className="flex-1">
          <img src="Image 2.png" className="w-full h-auto" alt="App preview" />
        </div>
      </div>
    </div>
  );
};

export default DownloadInfo;
